// Copyright (c) Docugami, Inc. All rights reserved.

import { Modal } from "@fluentui/react";
import { IDocumentCommand } from "components/file_management/DocumentCommand";
import { AddDocsView } from "components/myContentExplorer/AddDocsView";
import { ClusterInfo } from "networking/api";
import { useState } from 'react';
import { usePageLimits } from "./PageLimits";

export function useUploadToDocsetCommand(docSet: ClusterInfo, onComplete?: (error?: any) => void): IDocumentCommand {
    const [isActive, setIsActive] = useState(false);
    const { pageUploadDisabled } = usePageLimits();

    function getVisual() {
        if (!isActive) {
            return null;
        }

        return (
            <Modal
                isOpen={isActive}
                styles={{
                    main: {
                        maxWidth: "75%",
                        minWidth: "1000px",
                        height: "content",
                        maxHeight: "60%",
                        minHeight: "500px",
                        borderRadius: "10px",
                        display: "flex"
                    },
                }}
                isDarkOverlay={false} >
                <AddDocsView onComplete={() => { setIsActive(false); onComplete?.(); }} onDismiss={() => setIsActive(false)} docSetId={docSet.clusterId} />
            </Modal>
        )
    }

    return {
        id: "UploadToDocsetCommand",
        isActive: isActive,
        label: "Upload Files",
        isEnabled: !docSet.isDocugamiCluster && !pageUploadDisabled,
        visual: getVisual(),
        execute: () => setIsActive(true)
    }
}